import { provideTransloco, provideTranslocoMissingHandler } from '@jsverse/transloco';
import { EnvironmentProviders, isDevMode, Provider } from '@angular/core';
import { TranslocoHttpLoader } from './transloco-http-loader';
import { ReportingMissingHandler } from './transloco-missing-handler';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from './locale.service';

export function provideAppTransloco(): (Provider | EnvironmentProviders)[] {
  return [
    provideTransloco({
      config: {
        availableLangs: [...SUPPORTED_LOCALES],
        defaultLang: DEFAULT_LOCALE,
        fallbackLang: DEFAULT_LOCALE,
        // Re-renders pipes/structural directives when the active lang
        // changes — required for the language switcher to flip the UI
        // without a route navigation.
        reRenderOnLangChange: true,
        // `prodMode: true` disables Transloco's built-in dev-only
        // warnings (unnecessary in prod). Missing-key visibility comes
        // from the custom `ReportingMissingHandler` below, which logs
        // in every environment (deduped) so a stale-cache / missing-
        // translation incident is observable in prod without spamming.
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    provideTranslocoMissingHandler(ReportingMissingHandler),
  ];
}
